





































































import Vue from 'vue';
import DestintionDetailsRow from './dest-details-row.vue';
import TripSamples from './sample-cards-row.vue';
import {
  Trip,
  TripOptionsRecommendation,
  TripOptionsRecommendationCategory,
} from '@/store/api/download-destination-trips';
import {getAllSolutionFilters} from '@/store/state/helpers';
import {FilterTag} from '@/views/amex/app-types';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import {
  filterForUnique,
  buildCardsfromRecommendation,
  RoutesBuilder,
  DestinationDetailsCardInfo,
  EMPTY_RECOMMENDATIONS,
  filterByPrimaryCategory,
  FILTER_MODE,
} from './dest-details-helper';

export default Vue.extend({
  components: {
    DestintionDetailsRow,
    TripSamples,
  },
  name: 'DestinationDetails',
  props: {
    img: String,
    location: String,
    city: String,
    description: String,
    selectedTrip: Object,
    isLoading: {
      type: Boolean,
      default: false,
    },
    recommendations: {
      type: Array,
      default: () => EMPTY_RECOMMENDATIONS as TripOptionsRecommendation[],
    },
    samples: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isTextTruncated: true,
      maxTextLength: 300,
      UserActivityCategoryEnum,
      FILTER_MODE,
    };
  },
  computed: {
    visibleDescription(): string {
      const defaultDescription = 'No Information Available';
      return this.description || defaultDescription;
    },
    mainTripSample(): Trip {
      return this.samples[0] as Trip;
    },
    matchedFlights(): DestinationDetailsCardInfo[] {
      const recommendationsByCategory = filterByPrimaryCategory(
        this.recommendations as TripOptionsRecommendation[],
        UserActivityCategoryEnum.FLIGHT,
      );
      return recommendationsByCategory
        ? buildCardsfromRecommendation(recommendationsByCategory, this.mainTripSample).filter(filterForUnique)
        : [];
    },
    matchedStays(): DestinationDetailsCardInfo[] {
      const recommendationsByCategory = filterByPrimaryCategory(
        this.recommendations as TripOptionsRecommendation[],
        UserActivityCategoryEnum.ACCOMMODATION,
      );
      return recommendationsByCategory
        ? buildCardsfromRecommendation(recommendationsByCategory, this.mainTripSample).filter(filterForUnique)
        : [];
    },
    matchedDining(): DestinationDetailsCardInfo[] {
      const recommendationsByCategory = filterByPrimaryCategory(
        this.recommendations as TripOptionsRecommendation[],
        UserActivityCategoryEnum.DINING,
      );
      return recommendationsByCategory
        ? buildCardsfromRecommendation(recommendationsByCategory, this.mainTripSample).filter(filterForUnique)
        : [];
    },
    matchedActivities(): DestinationDetailsCardInfo[] {
      const recommendationsByCategory = filterByPrimaryCategory(
        this.recommendations as TripOptionsRecommendation[],
        UserActivityCategoryEnum.EXPERIENCE,
      );
      return recommendationsByCategory
        ? buildCardsfromRecommendation(recommendationsByCategory, this.mainTripSample).filter(filterForUnique)
        : [];
    },
    includedTags(): FilterTag[] {
      // return copy of tags that are selected, but de-select them
      return getAllSolutionFilters()
        .filter((tag) => tag.value)
        .map((tag) => ({...tag, value: false}));
    },
    flightsTags(): FilterTag[] {
      const tagsByDomain = this.includedTags.filter((tag) => tag.domain === UserActivityCategoryEnum.TRANSPORTATION);
      return tagsByDomain;
    },
    staysTags(): FilterTag[] {
      const tagsByDomain = this.includedTags.filter((tag) => tag.domain === UserActivityCategoryEnum.ACCOMMODATION);
      return tagsByDomain;
    },
    diningsTags(): FilterTag[] {
      const tagsByDomain = this.includedTags.filter((tag) => tag.domain === UserActivityCategoryEnum.DINING);
      return tagsByDomain;
    },
    activitiesTags(): FilterTag[] {
      const tagsByDomain = this.includedTags.filter((tag) => tag.domain === UserActivityCategoryEnum.EXPERIENCE);
      return tagsByDomain;
    },
  },
  methods: {
    onAddPreferences(category: string) {
      this.$emit('on-add-preferences', category);
    },
    getExploreAllUrlByCategory(category: string) {
      if (!this.mainTripSample) {
        return '';
      }

      // remove the + part from the trip id. Id format is: <UUID>+<Theme name>
      const tripId = this.mainTripSample.trip_id;
      // const tripId = this.mainTripSample.trip_id.replace(/\+.*$/g, '');
      return RoutesBuilder.exploreAllRoute(category, tripId, this.mainTripSample.context.name);
    },
    isCategoryLoading(category: TripOptionsRecommendationCategory): boolean {
      return !!filterByPrimaryCategory(this.recommendations as TripOptionsRecommendation[], category)?.isLoading;
    },
  },
});
